import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { clearBrokerProfile, getBrokerProfile } from "../../pages/Broker/BrokerService";
import { getBrokerBasePath } from "./brokerPaths";

const BrokerRouteGuard = ({ children }) => {
  const location = useLocation();
  const profile = getBrokerProfile();
  const hasToken = Boolean(localStorage.getItem("BearerToken"));
  const isAuthenticated = hasToken && profile?.role === "broker_admin";

  // If only one half of the session survived (e.g. a 401 cleared the bearer
  // token but left the cached profile), tear the rest down so the login page
  // renders clean instead of bouncing back to a guarded page.
  useEffect(() => {
    if (!isAuthenticated && (hasToken || profile)) {
      clearBrokerProfile();
    }
  }, [isAuthenticated, hasToken, profile]);

  if (!isAuthenticated) {
    return <Navigate to={getBrokerBasePath(location.pathname)} replace state={{ from: location }} />;
  }
  return children;
};

export default BrokerRouteGuard;
